import React from 'react';

interface INavigationButtonProps {
  label: string | React.ReactNode;
  onClick: () => void;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  isActive?: boolean;
  variant?: 'default' | 'danger';
  className?: string;
  isMobile?: boolean;
}

const NavigationButton: React.FC<INavigationButtonProps> = ({
  label,
  onClick,
  icon,
  iconPosition = 'left',
  isActive = false,
  variant = 'default',
  className = '',
  isMobile = false,
}) => {
  // Base styles
  const baseStyles = 'w-full text-left transition-all font-poppins font-medium flex items-center';
  
  // Mobile vs Desktop sizing
  const sizeStyles = isMobile
    ? 'py-4 px-6 text-base'
    : 'py-3 px-2 text-sm';
  
  // Active state styles (for navigation items)
  const activeStyles = isActive
    ? 'text-primary border-l-4 border-primary bg-brightPurple'
    : '';
  
  // Variant styles
  const variantStyles = variant === 'danger'
    ? 'text-redDanger'
    : isActive
      ? 'text-primary'
      : 'text-darkBlue';
  
  // Hover styles
  const hoverStyles = variant === 'danger'
    ? 'hover:opacity-80'
    : isActive
      ? ''
      : 'hover:text-primary';
  
  // Icon styles
  const iconStyles = 'w-5 h-5 flex-shrink-0';
  const iconColorStyles = variant === 'danger' ? 'text-redDanger' : '';
  
  // Layout styles based on icon position
  const layoutStyles = iconPosition === 'right'
    ? 'justify-between'
    : 'gap-3';

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${sizeStyles} ${activeStyles} ${variantStyles} ${hoverStyles} ${layoutStyles} ${className}`}
    >
      {icon && iconPosition === 'left' && (
        <span className={`${iconStyles} ${iconColorStyles}`}>
          {icon}
        </span>
      )}
      <span className={`whitespace-nowrap leading-[112%] ${variant === 'danger' ? 'text-redDanger' : ''}`}>
        {label}
      </span>
      {icon && iconPosition === 'right' && (
        <span className="flex-shrink-0">
          {icon}
        </span>
      )}
    </button>
  );
};

export default NavigationButton;

